export class ErrorResponse {
    statusCode?: number;
    operationCode?: string;
    additionalMessage?: string;
}

export class PageResponse extends ErrorResponse {
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    totalElements: number;
    totalPages: number;
    sort?: Sort;
}

export class Sort {
    ascending: true;
    descending: false;
    direction: string;
    ignoreCase: false;
    nullHandling: string;
    property: string;
}

